<template>
  <div class="storytelling-container">
    
    
    <div ref="gameContainer" class="game-container"></div>
    <h2 class="orbitron-title mb-3">{{ tituloActual }}</h2>

    <!-- Indicadores de viñetas (Bullets) -->
    <div class="carousel-bullets">
      <button 
        v-for="(escena, index) in escenas" 
        :key="index"
        class="bullet"
        :class="{ active: index === idxActual }"
        :aria-label="`Ir a la viñeta ${index + 1}`"
        @click="irAEscena(index)"
      ></button>
    </div>


    <div class="controls">


    <v-btn color="primary" elevation="0" rounded :disabled="idxActual === 0" @click="moverEscena(-1)">
        ◄ Anterior
    </v-btn>
    <v-btn color="primary" elevation="0" rounded :disabled="isPlaying" @click="reproducir">
        ▶ Reproducir
    </v-btn>
    <v-btn color="primary" elevation="0" rounded :disabled="idxActual === escenas.length - 1" @click="moverEscena(1)">
        Siguiente ►
    </v-btn>

    </div>
  </div>
</template>

<script>
import * as Phaser from 'phaser';

export default {
  name: 'StorytellingRetro',
  data() {
    return {
      game: null,
      idxActual: 0,
      tokenAnim: 0,
      isPlaying: false,
      actores: {},
      escenas: [
        {
          titulo: "Compra activos en el mercado",
          fondo: { imagenUrl: '/tutorial/fondo_mercado.png' },
          objetos: [
            {
              id: 'jugador',
              spriteUrl: '/tutorial/sprites-simulito-tutorial.png',
              frameW: 60, frameH: 40, scale: 8, x: 100, y: 250,
              frameQuieto: 0,
              acciones: {
                caminar: { frames: [0, 1], frameRate: 10, loop: true },
                coger:   { frames: [2, 3, 4, 5, 6], frameRate: 5, loop: false },
                saltar:  { frames: [1], frameRate: 10, loop: false }
              }
            }
          ],
          pasos: [
            { objetivo: 'jugador', accion: 'caminar', x: 250, duracion: 1500 },
            { objetivo: 'jugador', accion: 'decir', texto: "¡Anda!\nEsta central de ciclo combinado \nestá de oferta", tiempo: 4000 },
            { objetivo: 'jugador', accion: 'decir', texto: "Me la llevo", tiempo: 2000 },
            { objetivo: 'jugador', accion: 'coger', duracion: 1500 },
            { objetivo: 'jugador', accion: 'caminar', x: 1000, duracion: 3500 },
          ]
        },
        {
          titulo: "Configura tu cartera de activos",
          fondo: { imagenUrl: '/tutorial/fondo_huecos.png' },
          objetos: [
            {
              id: 'caja_eolica',
              spriteUrl: '/tutorial/sprites-simulito-tutorial.png',
              frameW: 60, frameH: 40, scale: 2, x: 440, y: -200,
              frameQuieto: 22,
              acciones: {
                caida: { frames: [22], frameRate: 5, loop: false }
              }
            },
            {
              id: 'caja_nuclear',
              spriteUrl: '/tutorial/sprites-simulito-tutorial.png',
              frameW: 60, frameH: 40, scale: 4, x: 240, y: -200,
              frameQuieto: 22,
              acciones: {
                caida: { frames: [22], frameRate: 5, loop: false }
              }
            }
          ],
          pasos: [
            { objetivo: 'caja_eolica', accion: 'caida', duracion: 2000, y: 180, mover: true },
            { objetivo: 'caja_eolica', accion: 'decir', texto: "Soy una central eólica", tiempo: 2000 },
            { objetivo: 'caja_nuclear', accion: 'caida', duracion: 2000, y: 300, mover: true },
            { objetivo: 'caja_nuclear', accion: 'decir', texto: "Y yo una central nuclear", tiempo: 2000 }
          ]
        },
        {
          titulo: "Gestiona diariamente la producción de tu cartera",
          fondo: { imagenUrl: '/tutorial/fondo_huecos.png' },
          objetos: [
            {
              id: 'entrenador',
              spriteUrl: '/tutorial/sprites-simulito-tutorial.png',
              frameW: 60, frameH: 40, scale: 3, x: 120, y: 150,
              frameQuieto: 23,
              acciones: {
                dirige: { frames: [23, 24], frameRate: 5, loop: true }
              }
            },
            {
              id: 'caja_eolica',
              spriteUrl: '/tutorial/sprites-simulito-tutorial.png',
              frameW: 60, frameH: 40, scale: 2, x: 440, y: -200,
              frameQuieto: 22,
              acciones: {
                caida: { frames: [22], frameRate: 5, loop: false }
              }
            },
            {
              id: 'caja_nuclear',
              spriteUrl: '/tutorial/sprites-simulito-tutorial.png',
              frameW: 60, frameH: 40, scale: 4, x: 240, y: -200,
              frameQuieto: 22,
              acciones: {
                caida: { frames: [22], frameRate: 5, loop: false }
              }
            }
          ],
          pasos: [
            { objetivo: 'entrenador', accion: 'dirige', duracion: 0, mover: false },
            { objetivo: 'caja_eolica', accion: 'caida', duracion: 0, y: 180, mover: false },
            { objetivo: 'caja_nuclear', accion: 'caida', duracion: 0, y: 300, mover: false },
            { objetivo: 'entrenador', accion: 'dirige', duracion: 2000, mover: false },
            { objetivo: 'entrenador', accion: 'decir', texto: "Al banquillo, \n central eólica", tiempo: 2000 },
            { objetivo: 'entrenador', accion: 'decir', texto: "Que mañana\n no hay viento", tiempo: 2000 },
            { objetivo: 'caja_eolica', accion: 'caida', duracion: 2000, y: -200, mover: true }
          ]
        },
        {
          titulo: "Vende los activos que ya no te interesen",
          fondo: { imagenUrl: '/tutorial/fondo_parque.png' },
          objetos: [
            {
              id: 'jugador',
              spriteUrl: '/tutorial/sprites-simulito-tutorial.png',
              frameW: 60, frameH: 40, scale: 8, x: 100, y: 250,
              frameQuieto: 7,
              acciones: {
                interactuar: { frames: [7, 8, 9, 10, 11, 12], frameRate: 5, loop: true }
              }
            }
          ],
          pasos: [
            { objetivo: 'jugador', accion: 'interactuar', duracion: 3000, x: 400, mover: false },
            { objetivo: 'jugador', accion: 'decir', texto: "¡Solares a buen precio!", tiempo: 2000 },
            { objetivo: 'jugador', accion: 'decir', texto: "¡Venga nena que me las quitan de las manos!", tiempo: 2000 }
          ]
        },
        {
          titulo: "¡O haz clausulazos a tus rivales!",
          fondo: { imagenUrl: '/tutorial/fondo_parque.png' },
          objetos: [
            {
              id: 'jugador',
              spriteUrl: '/tutorial/sprites-simulito-tutorial.png',
              frameW: 60, frameH: 40, scale: 8, x: 100, y: 250,
              frameQuieto: 21,
              acciones: {
                despistado: { frames: [15, 16, 17], frameRate: 5, loop: true },
                desaparicion: { frames: [17, 18], frameRate: 30, loop: true },
                sorpresa: { frames: [19, 20], frameRate: 5, loop: false },
                triste: { frames: [21], frameRate: 5, loop: false }
              }
            }
          ],
          pasos: [
            { objetivo: 'jugador', accion: 'despistado', duracion: 2000, x: 400, mover: false },
            { objetivo: 'jugador', accion: 'desaparicion', duracion: 2000, x: 400, mover: false },
            { objetivo: 'jugador', accion: 'sorpresa', duracion: 2000, x: 400, mover: false },
            { objetivo: 'jugador', accion: 'decir', texto: "¡Oh no!¡Donde está mi nuclear!", tiempo: 2000 },
            { objetivo: 'jugador', accion: 'triste', duracion: 1000, x: 400, mover: false }
          ]
        },
        {
          titulo: "¡Y gana la Electroliga!",
          fondo: { imagenUrl: '/tutorial/fondo_final.png' },
          objetos: [
            {
              id: 'jugador',
              spriteUrl: '/tutorial/sprites-simulito-tutorial.png',
              frameW: 60, frameH: 40, scale: 8, x: 100, y: 250,
              frameQuieto: 13,
              acciones: {
                saltar2: { frames: [13, 14], frameRate: 8, loop: true }
              }
            }
          ],
          pasos: [
            { objetivo: 'jugador', accion: 'saltar2', duracion: 5000, x: 400, mover: false }
          ]
        }
      ]
    };
  },
  computed: {
    tituloActual() {
      return this.escenas[this.idxActual]?.titulo || 'Cargando...';
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.iniciarJuego();
    });
  },
  beforeDestroy() {
    this.destruirJuego();
  },
  beforeUnmount() {
    this.destruirJuego();
  },
  methods: {
    destruirJuego() {
      if (this.game) {
        this.game.destroy(true);
        this.game = null;
      }
    },
    iniciarJuego() {
      if (this.game) this.destruirJuego();

      const self = this;

      class EscenaDinamica extends Phaser.Scene {
        preload() {
          const datos = self.escenas[self.idxActual];
          if (datos.fondo && datos.fondo.imagenUrl) {
            this.load.image(`fondo_${self.idxActual}`, datos.fondo.imagenUrl);
          }
          
          datos.objetos.forEach(obj => {
            this.load.spritesheet(obj.id, obj.spriteUrl, { 
              frameWidth: obj.frameW, 
              frameHeight: obj.frameH 
            });
          });
        }

        create() {
          const datos = self.escenas[self.idxActual];
          
          if (datos.fondo && datos.fondo.imagenUrl) {
            const fondo = this.add.image(0, 0, `fondo_${self.idxActual}`).setOrigin(0, 0);
            fondo.setDisplaySize(800, 450);
          }

          self.actores = {};
          datos.objetos.forEach(obj => {
            Object.keys(obj.acciones).forEach(nombreAccion => {
              const configAccion = obj.acciones[nombreAccion];
              const keyAnim = `${obj.id}_${nombreAccion}`;
              
              if (!this.anims.exists(keyAnim)) {
                this.anims.create({
                  key: keyAnim,
                  frames: this.anims.generateFrameNumbers(obj.id, { frames: configAccion.frames }),
                  frameRate: configAccion.frameRate || 10,
                  repeat: configAccion.loop ? -1 : 0
                });
              }
            });

            const sprite = this.add.sprite(obj.x, obj.y, obj.id, obj.frameQuieto).setScale(obj.scale);
            self.actores[obj.id] = self.crearActor(this, sprite, obj);
          });

          self.reproducir();
        }
      }

      const config = {
        type: Phaser.AUTO,
        width: 800,
        height: 450,
        parent: this.$refs.gameContainer,
        pixelArt: true,
        scene: EscenaDinamica
      };

      this.game = new Phaser.Game(config);
    },

    crearActor(scene, sprite, config) {
      return {
        scene,
        sprite,
        config,
        txt: null,

        reset() {
          this.sprite.stop();
          this.sprite.setFrame(this.config.frameQuieto);
          this.sprite.setPosition(this.config.x, this.config.y);
          if (this.txt) this.txt.destroy();
        },

        animar({ nombreAccion, duracion = 1000, x, y, altura, yoyo = false, mover = true }) {
          return new Promise(res => {
            const animKey = `${this.config.id}_${nombreAccion}`;
            if (this.scene.anims.exists(animKey)) {
              this.sprite.play(animKey, true);
            }

            if (!mover) {
              if (x !== undefined) this.sprite.x = x;
              if (y !== undefined) this.sprite.y = y;
            }

            const desplazaX = mover && (x !== undefined && x !== this.sprite.x);
            const desplazaY = mover && (y !== undefined && y !== this.sprite.y);
            const tieneAltura = (altura !== undefined);

            let targetX = desplazaX ? x : this.sprite.x;
            let targetY = desplazaY ? y : this.sprite.y;

            if (tieneAltura) {
              targetY = this.sprite.y - altura;
              yoyo = true;
            }

            if (desplazaX || desplazaY || tieneAltura) {
              this.scene.tweens.add({
                targets: this.sprite,
                x: targetX,
                y: targetY,
                duration: yoyo ? duracion / 2 : duracion,
                yoyo: yoyo,
                onComplete: () => {
                  this.sprite.stop();
                  this.sprite.setFrame(this.config.frameQuieto);
                  res();
                }
              });
            } else {
              this.scene.time.delayedCall(duracion, () => {
                this.sprite.stop();
                this.sprite.setFrame(this.config.frameQuieto);
                res();
              });
            }
          });
        },

        decir(texto, tiempo) {
          return new Promise(res => {
            if (this.txt) this.txt.destroy();
            this.txt = this.scene.add.text(
              this.sprite.x, 
              this.sprite.y - (this.sprite.displayHeight / 2) - 20, 
              texto, 
              { 
                font: '20px sans-serif', 
                fill: '#000', 
                backgroundColor: '#fff', 
                padding: 5 
              }
            ).setOrigin(0.5);
            
            setTimeout(() => { 
              if (this.txt) this.txt.destroy(); 
              res(); 
            }, tiempo);
          });
        }
      };
    },

    async reproducir() {
      this.tokenAnim++;
      const miToken = this.tokenAnim;
      const datos = this.escenas[this.idxActual];
      
      this.isPlaying = true;

      Object.values(this.actores).forEach(actor => actor.reset());

      for (const paso of datos.pasos) {
        if (miToken !== this.tokenAnim) return;

        const actorTarget = this.actores[paso.objetivo];
        if (actorTarget) {
          if (paso.accion === 'decir') {
            await actorTarget.decir(paso.texto, paso.tiempo);
          } else {
            await actorTarget.animar({
              nombreAccion: paso.accion,
              duracion: paso.duracion,
              x: paso.x,
              y: paso.y,
              altura: paso.altura,
              yoyo: paso.yoyo || false,
              mover: paso.mover !== undefined ? paso.mover : true
            });
          }
        }
      }

      if (miToken === this.tokenAnim) {
        this.isPlaying = false;
      }
    },

    moverEscena(dir) {
      const nuevoIdx = this.idxActual + dir;
      this.irAEscena(nuevoIdx);
    },

    irAEscena(index) {
      if (index >= 0 && index < this.escenas.length && index !== this.idxActual) {
        this.idxActual = index;
        this.game.scene.scenes[0].scene.restart();
      }
    }
  }
};
</script>

<style scoped>
.orbitron-title {
  font-family: 'Orbitron', sans-serif;
  font-weight: bold;
  font-size: 1.1rem;
}

.storytelling-container {
  background: #ffffff;
  color: #222222;
  font-family: sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
}

.game-container {
  width: 800px;
  height: 450px;
  border: 4px solid #cccccc;
  image-rendering: pixelated;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* Indicadores tipo Carrusel (Bullets) */
.carousel-bullets {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
}

.bullet {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #cccccc;
  border: none;
  padding: 0;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.2s ease;
}

.bullet:hover {
  background-color: #999999;
}

.bullet.active {
  background-color: #ffcc00;
  transform: scale(1.2);
}

.controls {
  margin-top: 15px;
  display: flex;
  gap: 10px;
}

button {
  background: #ffcc00;
  border: none;
  padding: 10px 15px;
  font-weight: bold;
  cursor: pointer;
  border-radius: 4px;
  color: #222;
}

button:disabled {
  background: #e0e0e0;
  color: #a0a0a0;
  cursor: not-allowed;
}
</style>